import * as React from "react";
import { observer, MobXProviderContext } from "mobx-react";
import { UitkTextInput, UitkFauxInput } from "uitk-react-input";
import { TravelersDialog } from "./TravelersDialog";
import { TravelersHiddenInputs } from "./TravelersHiddenInputs";
import { TravelersFieldProps, Travelers } from "../typings";
import { travelersSummary } from "../utils";
import { RouteStore } from "bernie-core";

export const TravelersField: React.FunctionComponent<TravelersFieldProps> = observer(props => {
  const routeStore: RouteStore = React.useContext(MobXProviderContext).routeStore;
  const inputRef = React.useRef<HTMLButtonElement | null>(null);
  const queryRouteId = "travelers-field";
  const {
    numOfAdults,
    numOfChildren,
    numOfInfants,
    flightSearch,
    hotelSearch,
    packageSearch
  } = props.metadata;
  const numOfTravelers =
    numOfAdults + numOfChildren + (props.config.withInfants ? numOfInfants : 0);
  const summary = travelersSummary(
    props.travelers.rooms,
    props.config.withRooms,
    numOfTravelers,
    props.l10n
  );

  const onClick = () => {
    routeStore.updateSearch({ pwaDialog: queryRouteId });
  };

  const onDismiss = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    routeStore.goBack();
  };

  const onSave = (travelers: Travelers) => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    routeStore.goBack();
    if (props.onSave) {
      props.onSave(travelers);
    }
  };

  // error thrown if no onChange handler is passed
  const dummyOnChange = () => null;

  return (
    <>
      <UitkTextInput
        icon={props.config.icon}
        className="is-hidden"
        label={props.l10n.formatText(props.config.labelToken)}
        value={summary}
        invalid={props.invalid}
        onChange={dummyOnChange}
      >
        <UitkFauxInput domRef={inputRef} onClick={onClick}>
          {summary}
        </UitkFauxInput>
        <TravelersDialog
          queryRouteId={queryRouteId}
          travelers={props.travelers}
          onDismiss={onDismiss}
          config={props.config}
          onSave={onSave}
          l10n={props.l10n}
        />
      </UitkTextInput>
      <TravelersHiddenInputs
        hiddenInputType={props.config.hiddenInputType}
        flightSearch={flightSearch}
        hotelSearch={hotelSearch}
        packageSearch={packageSearch}
      />
    </>
  );
});
